import { Common } from "components";
import { Container } from "@mui/material";

type Props = {};

export const Home = (props: Props) => {
  return (
    <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 }, position: "relative", zIndex: 1 }}>
      <Common.Intro />
      <Common.Overview />
      <Common.Technology />
      <Common.Project />
      <Common.Repo />
      <Common.Activity />
      <Common.Contact />
      <Common.ScrollTop window={() => window} />
    </Container>
  );
};
